import React, { useContext, useState } from 'react';
import { Box, Drawer } from '@mui/material';
import logoLarge from '../../Assets/ib_color.png';
import logoSmall from '../../Assets/IBsmallColorLogo.png';
import styles from './SideBarStyles.module.css';
import { DashboardInfoContext, DashboardInfoPayload } from "../../Context/dashboardContext";
import { ReactComponent as ArrowIcon }  from '../../Assets/SideBarOpenCloseLog.svg'
import CustomListItems from "./Components/CustomListItems";
import GlobalPopUp from "../global/globalPopUp/GLobalPopUp";

const drawerWidth = 200;
const smallDrawerWidth = 85;

const SideBar: React.FC = () => {
    const {
        isSidebarCollapsed,
        setIsSidebarCollapsed,
        currentActiveEnvironment
    } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const [changeEnvPopUpActive, setChangeEnvPopUpActive] = useState(false);

    const toggleDrawer = () => {
        setIsSidebarCollapsed((prevOpen) => !prevOpen);
    };

    return (
        <React.Fragment>
            <GlobalPopUp
                flagPopUp={changeEnvPopUpActive}
                setflagPopUp={setChangeEnvPopUpActive}
                heading="Change Environment"
                message="hello"
                section="changeEnvironment"
            />
            <Drawer
                variant="permanent"
                open={isSidebarCollapsed}
                className={styles.drawerStyle}
                sx={{
                    width: isSidebarCollapsed ? smallDrawerWidth : drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: isSidebarCollapsed ? smallDrawerWidth : drawerWidth,
                        transition: 'width 0.3s',
                        overflow: 'visible !important',
                        borderRight: 'none !important',
                    },
                }}
            >
                <Box className={styles.mainOuterDiv}>
                    <div className={styles.logoWrapper}>
                        <div className={styles.logoEnvNameCtn}>
                            <img
                                src={isSidebarCollapsed ? logoSmall : logoLarge}
                                alt="Logo"
                                className={styles.logoImage}
                                style={{maxWidth: isSidebarCollapsed ? '40px' : '150px'}}
                            />
                            {!isSidebarCollapsed && <div className={styles.activeEnvText} onClick={()=>{setChangeEnvPopUpActive(true)}}>
                                {currentActiveEnvironment}
                            </div>}
                        </div>
                            <ArrowIcon
                                alt="Toggle Arrow"
                                className={`${styles.arrowIcon} ${isSidebarCollapsed ? styles.collapsed : ''}`}
                                onClick={toggleDrawer}
                            />
                    </div>
                    <CustomListItems />
                </Box>
            </Drawer>
        </React.Fragment>
    );
};

export default SideBar;
